import type { childPartV1, childPartV2 } from "@/api/breakdownService";
import { TableCell } from "@mui/material";

interface MaterialCostDataProps {
  row: childPartV1 | childPartV2;
  isOpenSecondTierProcessColumn: boolean;
  secondTierProcessColumn: { id: number; name: string }[];
  isOpenOtherProcessColumn: boolean;
  otherProcessColumn: { id: number; name: string }[];
}

const MaterialCostData = ({
  row,
  isOpenSecondTierProcessColumn,
  secondTierProcessColumn,
  isOpenOtherProcessColumn,
  otherProcessColumn,
}: MaterialCostDataProps) => {
  return (
    <>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.total_material_cost ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_material_cost.material_cost ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 100,
          maxWidth: 100,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "center",
        }}
      >
        {row.child_part_material_cost.is_purchased ? "✔️" : "❌"}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_material_cost.scrap_price ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_material_cost.admin ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_material_cost.profit ?? 0).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 180,
          maxWidth: 180,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_material_cost.second_tier_process_total ?? 0).toFixed(2)}
      </TableCell>
      {isOpenSecondTierProcessColumn &&
        secondTierProcessColumn
          .sort((a, b) => a.id - b.id)
          .map((process) => (
            <TableCell
              key={process.id}
              sx={{
                minWidth: 120,
                maxWidth: 120,
                borderRight: "1px solid #e0e0e0",
                borderLeft: "1px solid #e0e0e0",
                textAlign: "right",
                fontSize: "0.9rem",
              }}
            >
              {Number(
                row.child_part_material_cost.second_tier_process.find(
                  (p) =>
                    ("ms_second_tier_process_v1_id" in p &&
                      p.ms_second_tier_process_v1_id === process.id) ||
                    ("part_material_second_tier_process_v2_id" in p &&
                      p.part_material_second_tier_process_v2_id === process.id),
                )?.cost ?? 0,
              ).toFixed(2)}
            </TableCell>
          ))}
      <TableCell
        sx={{
          minWidth: 180,
          maxWidth: 180,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(row.child_part_material_cost.other_process_total ?? 0).toFixed(2)}
      </TableCell>
      {isOpenOtherProcessColumn &&
        otherProcessColumn
          .sort((a, b) => a.id - b.id)
          .map((process) => (
            <TableCell
              key={process.id}
              sx={{
                minWidth: 120,
                maxWidth: 120,
                borderRight: "1px solid #e0e0e0",
                borderLeft: "1px solid #e0e0e0",
                textAlign: "right",
                fontSize: "0.9rem",
              }}
            >
              {Number(
                row.child_part_material_cost.other_process.find(
                  (p) =>
                    ("ms_other_process_v1_id" in p &&
                      p.ms_other_process_v1_id === process.id) ||
                    ("part_material_other_process_v2_id" in p &&
                      p.part_material_other_process_v2_id === process.id),
                )?.cost ?? 0,
              ).toFixed(2)}
            </TableCell>
          ))}
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(
          "pct" in row.child_part_material_cost
            ? row.child_part_material_cost.pct
            : row.child_part_material_cost.percent ?? 0,
        ).toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          minWidth: 120,
          maxWidth: 120,
          borderRight: "1px solid #e0e0e0",
          borderLeft: "1px solid #e0e0e0",
          textAlign: "right",
          fontSize: "0.9rem",
        }}
      >
        {Number(
          "other_pct" in row.child_part_material_cost
            ? row.child_part_material_cost.other_pct
            : row.child_part_material_cost.other_percent ?? 0,
        ).toFixed(2)}
      </TableCell>
    </>
  );
};

export default MaterialCostData;
